module.exports = __webpack_public_path__ + "media/images/iconbox/icon10-84186c10aa9d164470d9c43cb33f0cc1.png";